import {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import {Toaster as Sonner} from "sonner";
import "../../../components/sonner/sonner-overrides.css";

const Toaster = ({...props}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    const toaster = (
        <Sonner
            theme="light"
            position="bottom-right"
            offset={20}
            className="simms-sonner-toaster group"
            toastOptions={{
                classNames: {
                    toast:
                        "simms-sonner-toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-muted-foreground",
                    actionButton:
                        "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
                    cancelButton:
                        "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
                },
            }}
            {...props}
        />
    );

    return createPortal(toaster, document.body);
};

export {Toaster};
